import { EventType } from "./constant";

export const getEventType = (event) => {
    let type = event?.type;
    if(type === EventType.ALARM) {
        type = event?.attributes?.alarm;
    }
    return type;
};